export const unassignedUserId = '';
export const unassignedUserName = '';
export const unassignedDisplayName = 'Unassigned';
export const unassignedSearchId = '_none_';
